import React, { useState } from 'react';

import { Select } from '@mantine/core';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import { useTranslation } from 'react-i18next';
import { OnboardingIndustry } from 'shared/interfaces/Onboarding';

interface IndustrySelectionStepProps {
  updateOnboardingIndustry: (industry: OnboardingIndustry | string) => void;
}

export function IndustrySelectionStep({ updateOnboardingIndustry }: IndustrySelectionStepProps) {
  const { t } = useTranslation();

  const [data, setData] = useState<{ value: OnboardingIndustry | string; label: string }[]>(
    Object.entries(OnboardingIndustry)
      .map(([key, value]) => ({
        value: value,
        label: t(`ONBOARDING.INDUSTRY_SELECTION_STEP.INDUSTRY.${key}`)
      }))
      .sort(() => Math.random() - 0.5)
  );

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.INDUSTRY_SELECTION_STEP.TITLE')
      }}
      description={t('ONBOARDING.INDUSTRY_SELECTION_STEP.DESCRIPTION')}
      rightElement={
        <Select
          placeholder={t('ONBOARDING.INDUSTRY_SELECTION_STEP.PLACEHOLDER')}
          data={data}
          onChange={(value) => value && updateOnboardingIndustry(value)}
          searchable
          creatable
          getCreateLabel={(query) => `${query}`}
          onCreate={(query) => {
            const item = { value: query, label: query };
            updateOnboardingIndustry(query);
            setData((prev) => [...prev, item]);
            return item;
          }}
        />
      }
    />
  );
}
